// Screenname:Account Sub Head master
// Developer Name: Tharuni.
// Created date on: 7 / 5 / 2023
// Comments and Suggestions:
// TS File: Service
// Messages:
import httpbaseURL from "../common/axios";
class AccountSubHeadservices {
  createdata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AccountSubHeadMAS/Create",
      doc
    );
  }
  getdata(HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AccountSubHeadMAS/List?HospitalId=" + HospitalId
    );
  }
  getfindonedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.get(
      "/AccountSubHeadMAS/Get?id=" + doc + "&HospitalId=" + HospitalId
    );
  }
  updatedata(doc) {
    return httpbaseURL.httpMSInventoryUrl.post(
      "/AccountSubHeadMAS/Update",
      doc
    );
  }
  deletedata(doc, HospitalId) {
    return httpbaseURL.httpMSInventoryUrl.delete(
      "/AccountSubHeadMAS/Delete?id=" + doc + "&HospitalId=" + HospitalId
    );
  }
  active(DelID, Status, HospitalId) {
    debugger;
    return httpbaseURL.httpMSInventoryUrl.put(
      "AccountSubHeadMAS/Active?id=" +
        DelID +
        "&Status=" +
        Status +
        "&HospitalId=" +
        HospitalId
    );
  }
}
export default new AccountSubHeadservices();
